export const CONTACT_TYPE_BOOTHPERSONAL = 2;
